import * as React from 'react';

import { SpaceDetails } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const SpaceDetailsWrapper: React.FC<SharedUiWrapperProps> = ({ data, inputs }) => <SpaceDetails inputs={inputs} data={data} />;
SpaceDetailsWrapper.displayName = 'SpaceDetailsWrapper';

export const SharedUiSpaceDetailsWrapper = withSharedUiPropertyOffers(SpaceDetailsWrapper);
